import { memo } from 'react';
import Modal from '../Modal/Modal';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import { ReactComponent as CloseIcon } from '../../assets/images/close_icon.svg';

import styles from './PrivacyPolicyModal.module.css';


type PrivacyPolicyModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const PrivacyPolicyModal = memo(({ isOpen, onClose }: PrivacyPolicyModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.contentWrapper}>
        <div className={styles.contentHeader}>
          <h2>Privacy Policy</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <PrivacyPolicy />
        <button className={styles.cardButton} onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  )
});

export default PrivacyPolicyModal;